<template>
  <main class="text-center margin-t-large bg-greycolor">
    <div class="d-table mx-auto p-3 container">
      <h1
        class="font-heading-1 font-black font-family-concended font-all-upper m-0"
        v-html="IntroComponent.intoHeader"
      ></h1>

    </div>
    <p
      class="font-paragraph-1 d-table mx-auto mb-5 col-md-8 col-sm-12 paragraph-margins"
      v-html="IntroComponent.introContent"
    ></p>
    <!-- <p class="font-paragraph-1 my-4 font-family-bold d-none">
      Learn more about To Be Welcoming through our
      <a
        href="TBW_Landing_Page_FAQ.pdf"
        class="font-black border-black"
        target="_blank"
        rel="noopener noreferrer"
      >FAQ.</a>
    </p> -->
    <div id="intro-video" class="container mx-auto margin-t-large pb-0 col-md-8 col-xs-12">
      <div class="wrapper">
        <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
          <div
            class="wistia_responsive_wrapper"
            style="height:100%;left:0;position:absolute;top:0;width:100%;"
          >
            <div
              class="wistia_embed wistia_async_a69jl20los videoFoam=true"
              style="height:100%;position:relative;width:100%"
            >
              <div
                class="wistia_swatch"
                style="height:100%;left:0;opacity:0;overflow:hidden;position:absolute;top:0;transition:opacity 200ms;width:100%;"
              >
                <img
                  src="https://fast.wistia.com/embed/medias/a69jl20los/swatch"
                  style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                  alt
                  onload="this.parentNode.style.opacity=1;"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- <div id="intro-video" class="container mx-auto margin-t-large pb-0 col-md-8 col-xs-12"> -->
            <!-- <div class='embed-container'> -->
              <!-- <iframe src='https://player.vimeo.com/video/333820180' webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe> -->
              <!-- <iframe src="https://fast.wistia.net/embed/iframe/a69jl20los" allowtransparency="true" frameborder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen></iframe> -->
              <!-- <div class="wistia_embed wistia_async_j38ihh83m5" style="height:349px;width:620px">&nbsp;</div> -->
            <!-- </div> -->
    <!-- </div>  -->
  </main>
</template>

<script>
export default {
  props: {
    IntroComponent: Object
  },
  data() {
    return {
      checked: true
    };
  },
  created: function() {}
};
</script>
<style>
#intro-video {
  padding-top: 20px;
}
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>

